export const communicationTypeOptions = [
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
];

export const applicantCommunicationTypeOptions = [
  ...communicationTypeOptions,
  { value: 'reminder', label: 'Reminder' },
];
